/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1687
 */

var r = require(/* 634 */"../../1774/1253/634")
var o = require(/* 194 */"../../1648/194")
module.exports = /ipad|iphone|ipod/i.test(r) && undefined !== o.Pebble
